import template from './cashDeckButton.template.html';

export default {
  template,
  bindings: {
    ticket: '<',
    contacts: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(illionService, cashDeckService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.isInvited = false;

      ctrl.initialize = () => {
        ctrl.checkIsInvited();
      };

      ctrl.checkIsInvited = () => {
        illionService
          .bankStatementsIsInvited({ idTicket: ctrl.ticket.id, type: 'cashDeck' })
          .then((result) => {
            ctrl.isInvited = result.status;
          });
      };

      ctrl.createCashDeck = ($event, contact) => {
        if (!contact.person.contact.email || contact.isCompany) {
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: `${contact.getName()}`,
              p3: contact.isCompany ? 'must be person' : 'does not have email'
            },
            warn: true
          });

          return;
        }

        uiService.toast({
          text: {
            p1: 'Sending request',
            p2: `to ${contact.getName()}`,
            p3: 'please wait...'
          }
        });

        cashDeckService
          .create({
            idTicket: ctrl.ticket?.id,
            idContact: contact?.id,
            inviteViaEmail: true
          })
          .then((res) => {
            if (res.status !== true) {
              uiService.toast({
                text: {
                  p1: 'Sending request',
                  p2: `to ${contact.getName()}`,
                  p3: 'failed'
                },
                warn: true
              });

              return;
            }

            uiService.toast({
              text: {
                p1: 'Sending request',
                p2: `to ${contact.getName()}`,
                p3: 'successful'
              },
              success: true
            });

            ctrl.initialize();
            ctrl.onFinished();
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
